// extracted by mini-css-extract-plugin
module.exports = {"CollapseCollection":"CollapseCollection_CollapseCollection__WGG0C","CollapseCollection___noMargin":"CollapseCollection_CollapseCollection___noMargin__qevyX"};